/* src/app/modules/concept/conceptcontact/conceptcontact.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
.taxList {
  overflow-x: hidden;
  overflow-y: auto;
  height: 75px;
}
.resultList {
  overflow-y: auto;
  overflow-x: hidden;
  height: 150px;
}
/*# sourceMappingURL=conceptcontact.component.css.map */
